import React from "react";
import { Container } from "reactstrap";

// import Components
import BreadCrumb from "../../Components/Common/BreadCrumb";

import TileBoxs from "./TileBoxs";

const Widgets = () => {
  document.title = "Dashboard | " + process.env.REACT_APP_SITE_TITLE;
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Dashboard" pageTitle="Dashboard" />
          <TileBoxs />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Widgets;
